export const TEE_TIME_OVERLAY_LAYER = {
    dialog: { zIndex: 200, className: 'z-[200]' },
    nestedDialog: { zIndex: 300, className: 'z-[300]' },
    notification: { zIndex: 400, className: 'z-[400]' },
};
//# sourceMappingURL=overlay-layers.js.map